import React from 'react';
import './IconButton.css';

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Button variant style */
  variant?: 'default' | 'primary' | 'danger';
  /** Button size */
  size?: 'sm' | 'md' | 'lg';
  /** Icon content */
  icon: React.ReactNode;
  /** Accessible label for screen readers */
  'aria-label': string;
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      variant = 'default',
      size = 'md',
      icon,
      disabled,
      className = '',
      ...props
    },
    ref
  ) => {
    const classNames = [
      'ui-icon-button',
      `ui-icon-button--${variant}`,
      `ui-icon-button--${size}`,
      className,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <button
        ref={ref}
        className={classNames}
        disabled={disabled}
        {...props}
      >
        <span className="ui-icon-button__icon" aria-hidden="true">
          {icon}
        </span>
      </button>
    );
  }
);

IconButton.displayName = 'IconButton';
